import React from 'react';
import { Tr, Td, Checkbox, Text, Flex, Badge, Menu, MenuButton, IconButton, Portal, MenuList, MenuItem, Avatar, Button } from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { FaRegEye } from 'react-icons/fa6';
import { TbListDetails } from 'react-icons/tb';
import { RiFileTransferLine, RiDeleteBinLine } from "react-icons/ri";
import { FiEdit3 } from 'react-icons/fi';

const NewCommandesOrderRow = React.memo(({
    val,
    isSelected,
    selectedRowBg,
    handleCheckboxClick,
    saveScrollPosition,
    tableRefCurrent,
    navigate,
    textSM,
    currentBusiness,
    t,
    onOpenModalEditStatus,
    onOpenPreview,
    onOpenAlert,
    onOpenAssign,
    user,
    setQuickEditOrderId,
    onOpenQuickEdit,
    onOpenAssignOrder
}) => {
    return (
        <Tr
            bg={isSelected ? selectedRowBg : undefined}
            cursor="pointer"
            _hover={{ bg: "whiteAlpha.100" }}
            onClick={() => {
                saveScrollPosition(tableRefCurrent);
                navigate('/Detail-Gestion-confirmation', {
                    state: {
                        id: val.id,
                        tel: val.tel
                    }
                });
            }}
        >
            <Td position="sticky" left={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                <Checkbox size="md" colorScheme='purple' _focus={"none"} _active={'none'}
                    onChange={() => handleCheckboxClick(val.id)}
                    isChecked={isSelected} />
            </Td>
            <Td>
                <Text>{val.code}</Text>
            </Td>
            {["AdminClient", "ManagerClient"].includes(user.role) && <Td>
                {val.assigned_to ?
                    <Flex flexDirection="column">
                        <Text>{val.first_name}</Text>
                        <Text>{val.last_name}</Text>
                    </Flex>
                    :
                    <Text>-</Text>
                }
            </Td>}
            <Td>
                <Flex flexDirection={"column"}>
                    <Text fontWeight='semibold'>{val.full_name}</Text>
                    {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                </Flex>
            </Td>
            <Td>
                <Flex flexDirection={"column"}>
                    <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                    <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                </Flex>
            </Td>
            <Td>
                <a href={`https://wa.me/${val.tel}`} target='blank' onClick={(e) => e.stopPropagation()}>
                    {val.tel}
                </a>
            </Td>
            <Td>
                <Text>{val.sourceAPI}</Text>
            </Td>
            <Td>
                <Badge colorScheme='blue'
                    rounded="xl"
                    px={2}
                    cursor={["AdminClient", "ManagerClient"].includes(user.role) && 'pointer'}
                    onClick={(e) => {
                        e.stopPropagation();
                        ["AdminClient", "ManagerClient"].includes(user.role) && onOpenModalEditStatus(val.id)
                    }}>
                    {t(`${val.status_confirmation}`)}
                </Badge>
            </Td>
            <Td>
                <Text textAlign='center'>
                    {val.coupon ? val.couponTitle : '-'}
                </Text>
            </Td>
            <Td>
                <Flex gap={1} alignItems="center">
                    <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                    <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                </Flex>
                {
                    val?.coupon &&
                    <Flex gap={1} alignItems="center">
                        <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                        <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                    </Flex>
                }
            </Td>
            <Td>
                <Flex flexDirection="column">
                    <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                    <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                </Flex>
            </Td>
            <Td>
                {val.date_modification ? (
                    <Flex flexDirection="column">
                        <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                        <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                    </Flex>
                ) : (
                    <Text fontSize="sm" color="gray.400">-</Text>
                )}
            </Td>
            <Td onClick={(e) => e.stopPropagation()} {...(["AdminClient", "ManagerClient", "RespoSuiviClient"].includes(user.role) ? { position: "sticky", right: 0, zIndex: 1, bg: "white", _dark: { bg: "gray.700" } } : {})}>
                {["AdminClient", "ManagerClient", "RespoSuiviClient"].includes(user.role) ? (
                    <Menu>
                        <MenuButton
                            as={IconButton}
                            aria-label='Options'
                            icon={<HamburgerIcon />}
                            variant='outline'
                        />
                        <Portal>
                            <MenuList zIndex={9999}>
                                {["AdminClient", "ManagerClient"].includes(user.role) && (
                                    <>
                                        <MenuItem icon={<FaRegEye size={18} />} onClick={() => {
                                            onOpenPreview(val.id)
                                        }}>
                                            {t("Aperçu")}
                                        </MenuItem>
                                        <MenuItem icon={<TbListDetails size={18} />} onClick={() => {
                                            saveScrollPosition(tableRefCurrent);
                                            navigate('/Detail-Gestion-confirmation', {
                                                state: {
                                                    id: val.id,
                                                    tel: val.tel
                                                }
                                            });
                                        }}>
                                            {t("Détails")}
                                        </MenuItem>
                                        {val.status_confirmation !== 'Confirmé' && !val.status_stock && !val.status_delivery && !val.status_facture && (
                                            <MenuItem icon={<FiEdit3 size={18} />} onClick={() => {
                                                setQuickEditOrderId(val.id);
                                                onOpenQuickEdit();
                                            }}>
                                                {t("Quick Edit")}
                                            </MenuItem>
                                        )}
                                        <MenuItem icon={<RiFileTransferLine size={18} />} onClick={() => {
                                            handleCheckboxClick(val.id)
                                            onOpenAssign()
                                        }}>
                                            {t("Attribuer")}
                                        </MenuItem>
                                        <MenuItem icon={<RiDeleteBinLine size={18} />} onClick={() => {
                                            onOpenAlert(val.id, val.date_creation, val.date_modification)
                                        }}>
                                            {t("Supprimer")}
                                        </MenuItem>
                                    </>
                                )}
                                {["RespoSuiviClient"].includes(user.role) && (
                                    <>
                                        {!val.assigned_to && (
                                            <MenuItem icon={<RiFileTransferLine size={18} />} onClick={() => onOpenAssignOrder(user.id, val.id)}>
                                                {t("M'attribuer")}
                                            </MenuItem>
                                        )}
                                        <MenuItem icon={<FaRegEye size={18} />} onClick={() => onOpenPreview(val.id)}>
                                            {t("Aperçu")}
                                        </MenuItem>
                                    </>
                                )}
                            </MenuList>
                        </Portal>
                    </Menu>
                )
                    :
                    <>
                        {!val.assigned_to ? <Button variant='outline' colorScheme={'purple'} onClick={() => { onOpenAssignOrder(user.id, val.id) }}>
                            {t('Prends-la')}
                        </Button>
                            :
                            <Flex alignItems='center' gap={2}>
                                <Avatar h={25} w={25} src={user.image} />
                                <Flex flexDirection="column" justifyContent="center">
                                    <Text fontSize={12} fontWeight='semibold'>{user.first_name}</Text>
                                    <Text fontSize={12} fontWeight='semibold'>{user.last_name}</Text>
                                </Flex>
                            </Flex>
                        }
                    </>
                }
            </Td>
        </Tr>
    )
}, (prevProps, nextProps) => {
    return prevProps.val === nextProps.val && prevProps.isSelected === nextProps.isSelected;
});

export default NewCommandesOrderRow;
